export default require('./fr.json')
